import { useToast } from '@chakra-ui/react';
import OnlineRiskManagementFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/OnlineRiskManagementFormUI';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getOnlineRiskManagementDataTableColumns } from './RiskManagementDataTableMeta';
import onlineRiskManagementFormMeta from './RiskManagementFormMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

const RiskManagementMixedHandler = () => {
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['OnlineRiskManagement'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const columns = getOnlineRiskManagementDataTableColumns({
    isLoading,
  });

  return (
    <>
      <OnlineRiskManagementFormUI
        meta={onlineRiskManagementFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
      />

<CC.Box w={'100%'}>
      

      <CC.SimpleGrid columns={{ base: 2, lg: 6 }} spacing={10} my={10}>
        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Tran. Min</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Tran. Max</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Mnt. Limite</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>
        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Mnt. Excep</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Nbr. Limite</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Mnt.Aut.Cour.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Nbr.Aut.Cour.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Mnt.Usag.Cour.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Nbr.Usag.Cour.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Mnt.Dispo.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>

        <CC.Box shadow={'md'} width={'fit-content'} minW={'120px'} p={3}>
          <CC.Text fontWeight={'bold'}>Nbr.Dispo.</CC.Text>
          <CC.Text fontWeight={'bold'} fontSize={'lg'}>
            0000
          </CC.Text>
        </CC.Box>
      </CC.SimpleGrid>

      <CC.Box as={'div'} w={'100%'}>
        <CustomReactTable data={data || [{}, {}]} columns={columns} />
      </CC.Box>
    </CC.Box>
    </>
  );
};

export default RiskManagementMixedHandler;
